<template>
  <div
    v-if="showActivities"
    class="participant-activity-manager"
  >
    <h4>Curricular activities</h4>
    <div class="row">
      <div
        v-for="eventActivity of eventActivities"
        :key="eventActivity[0]"
        class="col-lg-6"
      >
        <div class="card day">
          <div class="card-header">
            Day: {{ eventActivity[0] }}
          </div>
          <ul class="list-group list-group-flush">
            <li
              v-for="activity in eventActivity[1]"
              :key="activity.id"
              class="list-group-item"
            >
              <div class="form-check form-check-inline">
                <input
                  :id="activityCbElId(activity)"
                  v-model="activity.selected"
                  type="checkbox"
                  class="form-check-input"
                  :disabled="readonly"
                >
                <label
                  :for="activityCbElId(activity)"
                  class="form-check-label"
                >
                  {{ fNameWithPrice(activity) }}
                </label>
              </div>
              <div
                v-if="showDetails(activity)"
                class="activity-details"
              >
                <div
                  v-if="activity.showDescription"
                  v-html="activity.description"
                />
                <div
                  v-if="showNotes(activity)"
                  class="mb-3"
                >
                  <label class="form-label">Notes (optional)</label>
                  <textarea
                    v-model="activity.notes"
                    class="form-control"
                    :readonly="readonly"
                  />
                </div>
              </div>
              <input
                v-model="activity.id"
                type="hidden"
                name="event_candidate[activities_attributes][][activity_id]"
              >
              <input
                v-model="activity.selected"
                type="hidden"
                name="event_candidate[activities_attributes][][selected]"
              >
              <input
                v-model="activity.notes"
                type="hidden"
                name="event_candidate[activities_attributes][][notes]"
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {computed, ref} from "vue"

interface CurricularActivity  {
  id: number;
  priceTypeId: number;
  price: string;
  name: string;
  selected: boolean;
  allowNotes: boolean;
  showDescription: boolean;
  description: string;
  notes: string;
}

type DailyActivities = [string, CurricularActivity[]];

declare global {
  interface Window {
    ParticipantActivities?: unknown;
  }
}

defineProps({
  readonly: {default: false, type: Boolean},
})

const eventActivities = ref<DailyActivities[]>([])

const showActivities = computed((): boolean => {
  return Array.isArray(eventActivities.value) && eventActivities.value.length > 0
})

const activityCbElId = (activity: CurricularActivity): string => {
  return `event-activity-${activity.id}`
}

const showNotes = (activity: CurricularActivity): boolean => {
  return activity.selected && activity.allowNotes
}

const showDetails = (activity: CurricularActivity): boolean => {
  return activity.selected && (activity.allowNotes || activity.showDescription)
}

const fNameWithPrice = (activity: CurricularActivity): string => {
  if (activity.priceTypeId == 1) {
    const price = parseFloat(activity.price)
    if (!isNaN(price) && isFinite(price) && price > 0) {
      return `${activity.name} (${price.toFixed(2)} €)`
    } else {
      return `${activity.name} (--- €)`
    }
  } else if (activity.priceTypeId == 2) {
    return `${activity.name} (free)`
  } else {
    return activity.name
  }
}

if (Array.isArray(window.ParticipantActivities)) {
  eventActivities.value = window.ParticipantActivities as DailyActivities[]
}
</script>
